import { Lightning as lng } from '@lightningjs/sdk';

export class EmptyPage extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Text: {
        x: w => w / 2,
        y: h => h / 2,
        text: {
          text: '404',
        },
      },
    };
  }

  _handleBack() {
    this.fireAncestors('$focusMenu');
    return true;
  }
}
